import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const FAQS = [{
  q: '¿Cuánto dura el programa?',
  a: '12 semanas. Una sesión por semana de ~55 minutos, más ejercicios diarios de 10 a 20 minutos y acceso directo por WhatsApp durante todo el proceso.'
}, {
  q: '¿Es grupal o uno a uno?',
  a: 'Completamente uno a uno. Trabajo con un máximo de 10 personas a la vez para poder acompañar de verdad a cada una.'
}, {
  q: '¿Y si no puedo comprometerme 12 semanas?',
  a: 'El proceso necesita consistencia. Si hoy no podés sostener las 12 semanas, esperá hasta que puedas hacerlo completo. Los esfuerzos a medias no funcionan acá.'
}, {
  q: '¿Necesito experiencia o conocimientos previos?',
  a: 'No. Lo único que necesitás es honestidad y disposición a mirarte.'
}, {
  q: '¿Qué pasa si no veo resultados?',
  a: 'Si después de dos semanas de trabajo real no sentís que algo se mueve, te devuelvo el dinero sin preguntas.'
}, {
  q: '¿Puedo hacerlo mientras trabajo?',
  a: 'Sí. Una sesión de 55 minutos por semana más 10 a 20 minutos diarios entran en cualquier agenda.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-45" data-mp="19t2977c25bdy">
      <div className="max-w-3xl mx-auto px-6" data-id="element-46" data-mp="1ol48oqa7u2dg">
        <FadeIn className="text-center mb-10 md:mb-14" data-id="element-47" data-mp="1jj54xfakd3fz">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand" data-id="element-48" data-mp="1xjzcxwtp92e4">
            Preguntas frecuentes
          </h2>
        </FadeIn>

        <div className="divide-y divide-charcoal-light border-y border-charcoal-light" data-id="element-49" data-mp="1sm69hbjs6mhj">
          {FAQS.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} data-id="element-50" data-mp="3udazy49z9h0a" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-6 py-5 text-left group" data-id="element-51" data-mp="3ue2ioeih7k95">
                  <span className="text-lg md:text-xl font-heading font-bold text-offwhite group-hover:text-sand transition-colors" data-id="element-52" data-mp="286rdj9yw0bu3">
                    {faq.q}
                  </span>
                  <span className="shrink-0 text-sand" data-id="element-53" data-mp="2h88qwkkwtzf3">
                    {isOpen ? <MinusIcon className="w-5 h-5" data-id="element-54" data-mp="2m7256f80tugb" /> : <PlusIcon className="w-5 h-5" data-id="element-55" data-mp="2m4z5t4kzaoyx" />}
                  </span>
                </button>

                <AnimatePresence initial={false} data-id="element-56" data-mp="2vwlqrsn4c2ev">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-57" data-mp="2vyoda2p2bdeu">
                      <p className="pb-6 pr-10 text-offwhite-dim leading-relaxed" data-id="element-58" data-mp="k90591dhnv66">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}